// SPDX-License-Identifier: AGPL-3.0-or-later

import {useVoiceGatewayStateVersion} from '@app/features/voice/engine/v2/VoiceEngineV2AppVoiceStateAdapter';
import VoiceChannelOccupancyStore from '@app/features/voice/state/VoiceChannelOccupancyStore';
import {useEffect, useState} from 'react';

export function formatVoiceChannelOccupancyDuration(elapsedMs: number): string {
	const totalSeconds = Math.max(0, Math.floor(elapsedMs / 1000));
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	if (hours > 0) {
		return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
	}
	return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function useVoiceChannelOccupancyDurationLabel(
	guildId: string,
	channelId: string,
	userCount: number,
): string | null {
	useVoiceGatewayStateVersion();
	const sinceUnix = VoiceChannelOccupancyStore.getOccupiedSinceUnix(guildId, channelId);
	const [, setTick] = useState(0);
	useEffect(() => {
		if (userCount <= 0) {
			return;
		}
		const interval = window.setInterval(() => {
			setTick((tick) => tick + 1);
		}, 1000);
		return () => window.clearInterval(interval);
	}, [userCount, guildId, channelId]);
	if (userCount <= 0 || sinceUnix == null) {
		return null;
	}
	return formatVoiceChannelOccupancyDuration(Date.now() - sinceUnix * 1000);
}
